export const sortByAlphabet = (a, b) => {
  if (a.title < b.title) {
    return -1;
  }

  if (a.title > b.title) {
    return 1;
  }

  return 0;
}

export function exclude(
  original = [],
  excluded = []
) {
  return original.filter(
    item => !excluded.includes(item)
  )
}
